import React from "react";
import { Tabs } from "antd";
import Away from "../../../../assets/teams/away.JPG";
import {players, substitutes, coach} from "../../mockData";

const { TabPane } = Tabs;

const TeamTab = () => {
  return (
    <>
      <Tabs defaultActiveKey="1" className="team-tab">
        <TabPane tab="Home Team" key="1">
          <TeamBox />
        </TabPane>
        <TabPane tab="Away Team" key="2">
          <TeamBox />
        </TabPane>
      </Tabs>
    </>
  );
};

const TeamBox = () => (
  <>
    <div className="team-tab-header">
      <img src={Away} width="40" />
    </div>
    <div className="team-player-box">
      {players.map((player, index) => (
        <div className="team-player p-5" key={index}>
          <p className="font-bold">{player.number}</p>
          <p className="font-bold">{player.name}</p>
          <p className="text-right font-bold">{player.position}</p>
        </div>
      ))}
    </div>

    <div className="team-tab-header">
      <h3>Substitutes</h3>
    </div>
    <div className="team-player-box">
      {substitutes.map((player, index) => (
        <div className="team-player p-5" key={index}>
          <p className="font-bold">{player.number}</p>
          <p className="font-bold">{player.name}</p>
          <p className="text-right font-bold">{player.position}</p>
        </div>
      ))}
    </div>

    <div className="team-tab-header">
      <h3>Coach</h3>
    </div>
    <div className="team-player-box">
      <h5>{coach}</h5>
    </div>
  </>
);

export default TeamTab;